import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {environment} from './environments/environment';


  // enableProdMode();
  if (window) {
    if (environment.production) {
      window.console.log = function () {
      };
    }
  }
if (environment.googleAnalyticsId) {
  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
  document.head.appendChild(gtagScript);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${environment.googleAnalyticsId}');
  `;
  document.head.appendChild(inlineScript);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
